/*****************************************************************
 * DO NOT MANUALLY EDIT THIS FILE!                               *
 *                                                               *
 * This file is auto-generated by 'yarn prepare'                 *
 *****************************************************************/

import { Route } from '@angular/router';
import { CourseConfirmCloseModalComponent } from './academy/instructor/dashboard-page/course-confirm-close-modal/course-confirm-close-modal.component';
import { CourseConfirmDeleteModalComponent } from './academy/instructor/dashboard-page/course-confirm-delete-modal/course-confirm-delete-modal.component';
import { CourseConfirmPublishModalComponent } from './academy/instructor/dashboard-page/course-confirm-publish-modal/course-confirm-publish-modal.component';
import { CourseConfirmUnpublishModalComponent } from './academy/instructor/dashboard-page/course-confirm-unpublish-modal/course-confirm-unpublish-modal.component';
import { ContestAwardModalComponent } from './contests/contest-award-modal/contest-award-modal.component';
import { ContestFilePreviewModalComponent } from './contests/contest-file-preview-modal/contest-file-preview-modal.component';
import { ContestInterestedFreelancersModalComponent } from './contests/contest-interested-freelancers-modal/contest-interested-freelancers-modal.component';
import { PreviewModalComponent } from './contests/contest-view/contest-entries-tab/entry-list/preview-modal/preview-modal.component';
import { FinopsOverlayComponent } from './financial-operations/common/finops-overlay/finops-overlay.component';
import { PaymentVerifyModalComponent } from './financial-operations/payment-verify/payment-verify-modal/payment-verify-modal.component';
import { PaymentsModalComponent } from './financial-operations/payments-deposit/payments-modal/payments-modal.component';
import { HireMePaymentVerifyModalComponent } from './hire-me/hire-me-payment-verify-modal/hire-me-payment-verify-modal.component';
import { HireMeWebappModalComponent } from './hire-me/hire-me-webapp-modal/hire-me-webapp-modal.component';
import { ArrowOnboardingModalComponent } from './jobs/job-post/arrow/onboarding-modal/arrow-onboarding-modal.component';
import { CallAlertModalComponent } from './messaging/messaging-chat/call-alert-modal/call-alert-modal.component';
import { ConfirmModalComponent } from './messaging/messaging-chat/confirm-modal/confirm-modal.component';
import { GroupchatManagementModalComponent } from './messaging/messaging-chat/groupchat-management-modal/groupchat-management-modal.component';
import { AwardModalComponent } from './projects/award-modal/award-modal.component';
import { BidAwardRevokeModalComponent } from './projects/bid-award-revoke-modal/bid-award-revoke-modal.component';
import { CloseBiddingModalComponent } from './projects/close-bidding-modal/close-bidding-modal.component';
import { HourlyAwardModalComponent } from './projects/hourly-award-modal/hourly-award-modal.component';
import { MilestoneCancelModalComponent } from './projects/milestone-cancel-modal/milestone-cancel-modal.component';
import { MilestoneConfirmModalComponent } from './projects/milestone-confirm-modal/milestone-confirm-modal.component';
import { MilestoneCreateModalComponent } from './projects/milestone-create-modal/milestone-create-modal.component';
import { MilestoneRequestModalComponent } from './projects/milestone-request-modal/milestone-request-modal.component';
import { ProjectDeleteModalComponent } from './projects/project-delete-modal/project-delete-modal.component';
import { ProjectEndModalComponent } from './projects/project-end-modal/project-end-modal.component';
import { ProjectFileRenameModalComponent } from './projects/project-files/project-file-rename-modal/project-file-rename-modal.component';
import { ProjectFileShareModalComponent } from './projects/project-files/project-file-share-modal/project-file-share-modal.component';
import { ProjectFilesPreviewModalComponent } from './projects/project-files/project-files-preview-modal/project-files-preview-modal.component';
import { MilestoneReleaseModalComponent } from './projects/project-view/project-view-payments/milestone-release-modal/milestone-release-modal.component';
import { ProjectEndBillingModalComponent } from './projects/project-view/project-view-payments/project-end-billing-modal/project-end-billing-modal.component';
import { UserPortfolioItemOverlayComponent } from './projects/project-view/user-profile-information/user-portfolio/user-portfolio-item-overlay/user-portfolio-item-overlay.component';
import { GiveGetModalComponent } from './referrals/give-get-modal/give-get-modal.component';
import { TaskModalComponent } from './tasks/task-modal/task-modal.component';
import { TutorialModalComponent } from './tutorial/home/tutorial-modal/tutorial-modal.component';

export const appModals: ReadonlyArray<Route> = [
  {
    component: CourseConfirmCloseModalComponent,
    loadChildren:
      'app/academy/instructor/dashboard-page/course-confirm-close-modal/course-confirm-close-modal.module#CourseConfirmCloseModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: CourseConfirmDeleteModalComponent,
    loadChildren:
      'app/academy/instructor/dashboard-page/course-confirm-delete-modal/course-confirm-delete-modal.module#CourseConfirmDeleteModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: CourseConfirmPublishModalComponent,
    loadChildren:
      'app/academy/instructor/dashboard-page/course-confirm-publish-modal/course-confirm-publish-modal.module#CourseConfirmPublishModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: CourseConfirmUnpublishModalComponent,
    loadChildren:
      'app/academy/instructor/dashboard-page/course-confirm-unpublish-modal/course-confirm-unpublish-modal.module#CourseConfirmUnpublishModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: ContestAwardModalComponent,
    loadChildren:
      'app/contests/contest-award-modal/contest-award-modal.module#ContestAwardModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: ContestFilePreviewModalComponent,
    loadChildren:
      'app/contests/contest-file-preview-modal/contest-file-preview-modal.module#ContestFilePreviewModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: ContestInterestedFreelancersModalComponent,
    loadChildren:
      'app/contests/contest-interested-freelancers-modal/contest-interested-freelancers-modal.module#ContestInterestedFreelancersModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: PreviewModalComponent,
    loadChildren:
      'app/contests/contest-view/contest-entries-tab/entry-list/preview-modal/preview-modal.module#PreviewModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: FinopsOverlayComponent,
    loadChildren:
      'app/financial-operations/common/finops-overlay/finops-overlay.module#FinopsOverlayModule',
    path: 'hack_path_not_used',
  },
  {
    component: PaymentVerifyModalComponent,
    loadChildren:
      'app/financial-operations/payment-verify/payment-verify-modal/payment-verify-modal.module#PaymentVerifyModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: PaymentsModalComponent,
    loadChildren:
      'app/financial-operations/payments-deposit/payments-modal/payments-modal.module#PaymentsModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: HireMePaymentVerifyModalComponent,
    loadChildren:
      'app/hire-me/hire-me-payment-verify-modal/hire-me-payment-verify-modal.module#HireMePaymentVerifyModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: HireMeWebappModalComponent,
    loadChildren:
      'app/hire-me/hire-me-webapp-modal/hire-me-webapp-modal.module#HireMeWebappModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: ArrowOnboardingModalComponent,
    loadChildren:
      'app/jobs/job-post/arrow/onboarding-modal/arrow-onboarding-modal.module#ArrowOnboardingModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: CallAlertModalComponent,
    loadChildren:
      'app/messaging/messaging-chat/call-alert-modal/call-alert-modal.module#CallAlertModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: ConfirmModalComponent,
    loadChildren:
      'app/messaging/messaging-chat/confirm-modal/confirm-modal.module#ConfirmModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: GroupchatManagementModalComponent,
    loadChildren:
      'app/messaging/messaging-chat/groupchat-management-modal/groupchat-management-modal.module#GroupchatManagementModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: AwardModalComponent,
    loadChildren:
      'app/projects/award-modal/award-modal.module#AwardModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: BidAwardRevokeModalComponent,
    loadChildren:
      'app/projects/bid-award-revoke-modal/bid-award-revoke-modal.module#BidAwardRevokeModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: CloseBiddingModalComponent,
    loadChildren:
      'app/projects/close-bidding-modal/close-bidding-modal.module#CloseBiddingModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: HourlyAwardModalComponent,
    loadChildren:
      'app/projects/hourly-award-modal/hourly-award-modal.module#HourlyAwardModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: MilestoneCancelModalComponent,
    loadChildren:
      'app/projects/milestone-cancel-modal/milestone-cancel-modal.module#MilestoneCancelModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: MilestoneConfirmModalComponent,
    loadChildren:
      'app/projects/milestone-confirm-modal/milestone-confirm-modal.module#MilestoneConfirmModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: MilestoneCreateModalComponent,
    loadChildren:
      'app/projects/milestone-create-modal/milestone-create-modal.module#MilestoneCreateModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: MilestoneRequestModalComponent,
    loadChildren:
      'app/projects/milestone-request-modal/milestone-request-modal.module#MilestoneRequestModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: ProjectDeleteModalComponent,
    loadChildren:
      'app/projects/project-delete-modal/project-delete-modal.module#ProjectDeleteModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: ProjectEndModalComponent,
    loadChildren:
      'app/projects/project-end-modal/project-end-modal.module#ProjectEndModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: ProjectFileRenameModalComponent,
    loadChildren:
      'app/projects/project-files/project-file-rename-modal/project-file-rename-modal.module#ProjectFileRenameModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: ProjectFileShareModalComponent,
    loadChildren:
      'app/projects/project-files/project-file-share-modal/project-file-share-modal.module#ProjectFileShareModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: ProjectFilesPreviewModalComponent,
    loadChildren:
      'app/projects/project-files/project-files-preview-modal/project-files-preview-modal.module#ProjectFilesPreviewModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: MilestoneReleaseModalComponent,
    loadChildren:
      'app/projects/project-view/project-view-payments/milestone-release-modal/milestone-release-modal.module#MilestoneReleaseModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: ProjectEndBillingModalComponent,
    loadChildren:
      'app/projects/project-view/project-view-payments/project-end-billing-modal/project-end-billing-modal.module#ProjectEndBillingModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: UserPortfolioItemOverlayComponent,
    loadChildren:
      'app/projects/project-view/user-profile-information/user-portfolio/user-portfolio-item-overlay/user-portfolio-item-overlay.module#UserPortfolioItemOverlayModule',
    path: 'hack_path_not_used',
  },
  {
    component: GiveGetModalComponent,
    loadChildren:
      'app/referrals/give-get-modal/give-get-modal.module#GiveGetModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: TaskModalComponent,
    loadChildren: 'app/tasks/task-modal/task-modal.module#TaskModalModule',
    path: 'hack_path_not_used',
  },
  {
    component: TutorialModalComponent,
    loadChildren:
      'app/tutorial/home/tutorial-modal/tutorial-modal.module#TutorialModalModule',
    path: 'hack_path_not_used',
  },
];
